<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialogMeasure" fullscreen transition="dialog-bottom-transition" scrollable>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('auditmeasure_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="save">{{ $t('save') }}</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md style="background-color: white;">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-card pa-2>
                <v-layout row wrap>
                  <v-flex xs3 sm3 d-flex pa-4>
                    <v-switch :label="$t('priority_label')" v-model="editedItem.priority"></v-switch>
                  </v-flex>

                  <v-flex xs9 sm9 d-flex pa-4>
                    <v-text-field
                      :counter="140"
                      :rules="rules"
                      v-model="editedItem.text"
                      :label="$t('measure_label')"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card>

              <v-card>
                <v-layout>
                  <v-flex xs3 pa-4>
                    <v-select
                      :items="statusList"
                      item-value="id"
                      item-text="description"
                      :label="$t('status_label')"
                      v-model="currentStatusId"
                    ></v-select>

                    <v-select
                      :items="measuretype"
                      item-value="id"
                      item-text="description"
                      :label="$t('measuretype_label')"
                      v-model="editedItem.measuretype"
                    ></v-select>

                    <MenuDatePicker
                      :label="$t('created_date_label')"
                      v-model="editedItem.createdDate"
                    />
                    <MenuDatePicker :label="$t('due_date_label')" v-model="editedItem.dueDate" />

                    <v-select
                      readonly
                      :items="users"
                      :label="$t('autor_label')"
                      item-value="id"
                      item-text="displayName"
                      v-model="author"
                    ></v-select>

                    <!--<UserAutocomplete
                        TODO: We should have this Dialog also generated automatically!
                      :selectedUser.sync="assignedTo"
                      :label="$t('assigned_to_label')"
                      required
                      :rules="[v => !!v || 'Item is required']"
                      chips
                    />-->

                    <UserAutocomplete
                      :selectedUser.sync="assignedTo"
                      :label="$t('assigned_to_label')"
                      chips
                    />
                  </v-flex>

                  <v-flex xs9 pa-4>
                    <v-textarea
                      :label="$t('measure_description')"
                      outline
                      v-model="editedItem.description"
                    ></v-textarea>

                    <v-divider></v-divider>

                    <v-textarea
                      v-if="currentConfig.dialog && currentConfig.dialog.cause_analysis"
                      :label="$t('measure_cause_analysis_description')"
                      outline
                      v-model="editedItem.cause_analysis"
                    ></v-textarea>

                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">{{ $t('cancel') }}</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<i18n>
{
  "de": {
    "auditmeasure_title": "Audit Maßnahme",
    "measure_label": "Maßnahme",
    "measuretype_label": "Typ",
    "priority_label": "Priorität",
    "created_date_label": "Erstellt am",
    "due_date_label": "Zu erledigen bis",
    "autor_label": "Autor",
    "assigned_to_label": "Zugewiesen an",
    "measure_description": "Beschreibung",
    "measure_cause_analysis_description": "Ursachenanalyse und genutzte Tools",
    "status_label": "Status",
    "cancel": "Abbrechen",
    "save": "Speichern"
  },
  "en": {
    "auditmeasure_title": "Audit Measure",
    "measure_label": "Measure",
    "measuretype_label": "Type",
    "priority_label": "Priority",
    "created_date_label": "Created",
    "due_date_label": "Due to",
    "autor_label": "Author",
    "assigned_to_label": "Assigned to",
    "measure_description": "Description",
    "measure_cause_analysis_description": "Root cause analysis",
    "status_label": "State",
    "cancel": "Cancel",
    "save": "Save"
  }
}
</i18n>

<script>
import UserAutocomplete from "@/components/controls/UserAutocomplete.vue";
import MenuDatePicker from "@/components/controls/MenuDatePicker";

import { mapActions, mapGetters } from "vuex";
import { api } from "@/store/modules/audits";
import { api as userApi } from "@/store/modules/users";
import { api as confApi } from "@/store/modules/configuration";

import _ from "lodash";

export default {
  props: {
    dialogMeasure: {
      default: false
    }
  },
  components: {
    UserAutocomplete,
    MenuDatePicker
  },
  data: () => ({
    menu1: false,
    menu2: false,
    today: new Date().toISOString().slice(0, 10),
    valid: true,
    rules: [
      v => v.length <= 140 || "Max 140 characters",
      v => !!v || "Item is required"
    ],
    editedItem: {}
  }),
  created() {
    this.editedItem = _.cloneDeep(this.getDialogItem) || {};
  },
  computed: {
    ...mapGetters(userApi.namespace, [
      userApi.getters.getLoadedUsers,
      userApi.getters.forceGetUserByText
    ]),
    ...mapGetters(api.namespace, [
      api.getters.getAuditId,
      api.getters.getAuditItemId,
      api.getters.getDeviationId,
      api.getters.getMeasureId,
      api.getters.getDialogAction,
      api.getters.getDialogItem
    ]),
    ...mapGetters(confApi.namespace, [confApi.getters.measure]),
    currentConfig() {
      const config = this.measure;
      return config;
    },
    statusList() {
      const status = this.measure.workflow.status;
      return status;
    },
    currentStatusId: {
      get() {
        console.log("currentStatusId:get");
        const stored_status = this.editedItem.status;

        let status_item = this.measure.workflow.status.find(item => {
          return item.id == stored_status;
        });

        if (typeof status_item === "undefined") {
          console.warn(
            "status id not mapable try description",
            stored_status,
            this.measure.workflow.status
          );
          status_item = this.measure.workflow.status.find(item => {
            return item.description == stored_status;
          });
        }
        if (typeof status_item === "undefined") {
          console.error(
            "status id not mapable",
            stored_status,
            this.measure.workflow.status
          );
          return "0";
        } else {
          return status_item.id;
        }
      },
      set(value) {
        console.log("currentStatusId:set", value);
        this.editedItem.status = value;
      }
    },
    assignedTo: {
      get() {
        const stored_assigned_to = this.editedItem.assignedTo;
        if (typeof stored_assigned_to === "string") {
          const user = this.forceGetUserByText(stored_assigned_to);
          return user ? user.id || null : null;
        } else {
          return null;
        }
      },
      set(value) {
        this.editedItem.assignedTo = value;
      }
    },
    author: {
      get() {
        const stored_author = this.editedItem.autor;
        if (typeof stored_author === "string") {
          const user = this.forceGetUserByText(stored_author);
          return user ? user.id || null : null;
        } else {
          return null;
        }
      },
      set(value) {
        this.editedItem.autor = value;
      }
    },

    measuretype() {
      return this.measure.data.types.filter(type => type.hidden !== true);
    },
    users() {
      //TODO: Get only filtered Users
      return this.getLoadedUsers;
    },
    /*editedItem() {
      return this.getDialogItem;
    },*/
    isUpdate() {
      if (this.getDialogAction === "update") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions(api.namespace, [
      api.actions.createMeasure,
      api.actions.updateMeasure
    ]),
    close() {
      this.$emit("update:dialogMeasure", false);
      this.$emit("update:editedItem", {});
    },
    save() {
      if (this.$refs.form.validate()) {
        const measure = { ...this.editedItem };
        if (!measure.assignedTo) {
          measure.assignedTo = null;
        }

        const payload = {
          audit_id: this.getAuditId,
          audititem_id: this.getAuditItemId,
          deviation_id: this.getDeviationId,
          measure_id: this.getMeasureId || "",
          data: measure
        };

        console.log("Dialog Payload", payload);

        if (this.isUpdate) {
          console.log("Updateing");
          this.updateMeasure(payload);
        } else {
          console.log("Creating Measure");
          this.createMeasure(payload);
        }

        console.log("Schließen");
        this.close();
      }
    }
  }
};
</script>
